import { ArrowForward, Search } from "@mui/icons-material";
import {
  Box,
  InputAdornment,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import { useAppContext } from "AppContextProvider";
import { Center } from "components/Center";
import { ErrorHandler } from "components/ErrorHandler";
import { LoadingScreen } from "components/LoadingScreen";
import { Placeholder } from "components/Placeholder";
import { ResponsiveGrid, ResponsiveGridItem } from "components/ResponsiveGrid";
import { Account } from "data/interfaces";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ApiService, Error } from "services";

const AccountsPage = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const { state, setState } = useAppContext();

  const [error, setError] = useState<Error>();

  useEffect(() => {
    ApiService.getAccounts()
      .then((accounts: Account[]) => {
        if (accounts.length === 1)
          navigate(`/accounts/${accounts[0].accountId}/users`);

        setState({ accounts, activeAccount: undefined });
        setLoading(false);
      })
      .catch((error: Error) => setError(error));
  }, [navigate, setState]);

  const [searchText, setsearchText] = useState("");
  let searchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    var lowerCase = e.target.value.toLowerCase();
    setsearchText(lowerCase);
  };

  const filteredAccounts = state.accounts
    .filter((account) => account.name.toLowerCase().includes(searchText))
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <ErrorHandler error={error}>
      <Box p={3}>
        {loading && <LoadingScreen title="Loading..." />}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ pb: 3 }}
        >
          <TextField
            variant="outlined"
            placeholder="Search"
            sx={{ width: "50%" }}
            onChange={searchHandler}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        {!loading && filteredAccounts.length === 0 && (
          <Center>
            <Placeholder>No accounts found</Placeholder>
          </Center>
        )}
        {!loading && filteredAccounts.length > 0 && (
          <ResponsiveGrid>
            {filteredAccounts.map((account) => (
              <ResponsiveGridItem key={account.accountId}>
                <ListItem sx={{ boxShadow: 1, p: 0 }}>
                  <ListItemButton
                    component={Link}
                    to={`/accounts/${account.accountId}/users`}
                  >
                    <ListItemText>
                      <Typography gutterBottom variant="h5" component="h2">
                        {account.name}
                      </Typography>
                    </ListItemText>
                    <ListItemIcon>
                      <ArrowForward />
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              </ResponsiveGridItem>
            ))}
          </ResponsiveGrid>
        )}
      </Box>
    </ErrorHandler>
  );
};

export default AccountsPage;
